const domainGuideLang = {
  Status: {
    ACTIVE: {
      Title: 'ACTIVE',
      ColumnTitle: 'Active',
    },
    INACTIVE: {
      Title: 'INACTIVE',
      ColumnTitle: 'Inactive',
    },
    DELETED: {
      Title: 'DELETED',
      ColumnTitle: 'Deleted',
    },
  },
  Detail: {
    EmptyValue: '-',
    NotFound: 'Domain guide not found',
    Fields: {
      DomainGuideId: 'Domain guide ID',
      Description: 'Description',
      Status: 'Status',
      TeamName: 'Assigned team',
      CreatedBy: 'Created by',
      CreatedAt: 'Created',
      UpdatedAt: 'Updated',
    },
    Assignment: {
      Title: 'Assignments',
      TeamPlaceholder: 'Select a team',
      SlackIdLabel: 'Slack IDs',
      SlackIdPlaceholder: 'Select a Slack ID',
      AddSlackId: 'Add Slack ID',
      NoSlackIds: 'No Slack IDs',
    },
    TeamOptions: {
      Sales: 'Sales',
      Recruiting: 'Recruiting',
      Operations: 'Operations',
    },
    SlackIdOptions: {
      Blake: 'Blake',
      Bianca: 'Bianca',
      Daniel: 'Daniel',
      Patrick: 'Patrick',
    },
    RawDomainGuide: {
      Title: 'Raw Domain Guide',
    },
    Rubric: {
      Title: 'Rubric',
      Subtitle: 'Defines what a passing case looks like for this guide. The teacher scores every case against it.',
      PassingDefinitionLabel: 'Passing definition',
      PassingDefinitionPlaceholder: 'Describe what a passing case looks like, the way you would brief a new teammate. ' +
        'For example: "The agent answered accurately using only information from this guide, escalated anything it was ' +
        'unsure about to a human, never promised pay, schedules, or outcomes we can\'t guarantee, kept a warm ' +
        'professional tone, and ended with a clear next step for the client or caregiver."',
      FailureCategoriesLabel: 'Failure categories',
      FailureCategoriesHint: 'When a case fails, the teacher picks one of these categories. ' +
        'Edit or remove the starter categories to match how this guide actually fails.',
      CategoryLabelPlaceholder: 'Category name',
      CategoryDescriptionPlaceholder: 'When should the teacher pick this category?',
      AutoFailLabel: 'Auto-fail',
      AutoFailHint: 'Auto-fail categories page the team as soon as the teacher sees one (once marking is live).',
      AddCategory: 'Add category',
      RemoveCategory: 'Remove category',
      Save: 'Save rubric',
      Saving: 'Saving...',
      SaveFailed: 'Could not save the rubric.',
      UpdatedAt: 'Last saved #{updatedAt}',
      NeverSaved: 'Not saved yet — starting from the starter template.',
      StarterDescriptions: {
        MissedEscalation: 'The case needed a human (complaint, safety concern, unusual request) and the agent handled it alone instead of escalating.',
        WrongInformation: 'The agent stated something factually wrong about our services, policies, pay, or the client/caregiver record.',
        Overpromised: 'The agent agreed with or promised whatever the person asked for instead of holding our actual position.',
        PolicyViolation: 'The agent did or said something our policies do not allow.',
        PoorTone: 'The response was cold, dismissive, or unprofessional in tone.',
        NoFollowUp: 'The agent left the conversation without a clear next step or a promised follow-up.',
      },
    },
    Marking: {
      Title: 'Marking',
      Subtitle: 'Controls whether the AI teacher reviews this guide\'s completed cases.',
      EnabledLabel: 'Teacher enabled',
      EnabledHint: 'The teacher scores this guide\'s completed cases against the rubric on every sweep.',
      LiveLabel: 'Page on auto-fail',
      LiveHint: 'Off = shadow mode: the teacher still scores every case, but auto-fail grades do not page anyone. ' +
        'Keep this off for the first week while you check the teacher\'s grades, then turn it on.',
      StakesLabel: 'Stakes',
      StakesOptions: {
        LOW: 'Low',
        MEDIUM: 'Medium',
        HIGH: 'High',
      },
      SampleRateLabel: 'Sample rate (%)',
      SampleRateHint: 'Share of completed cases the teacher reviews. Keep high-stakes guides at 100.',
      SampleRateInvalid: 'Sample rate must be a number between 0 and 100.',
      Save: 'Save marking settings',
      Saving: 'Saving...',
      SaveFailed: 'Could not save the marking settings.',
      RubricRequired: 'Add a rubric first — the teacher cannot score cases without one.',
    },
  },
};

export default domainGuideLang;
